import { render, staticRenderFns } from "./recontentTote.vue?vue&type=template&id=04a06bff&scoped=true&"
import script from "./recontentTote.vue?vue&type=script&lang=js&"
export * from "./recontentTote.vue?vue&type=script&lang=js&"
import style1 from "./recontentTote.vue?vue&type=style&index=1&id=04a06bff&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a06bff",
  null
  
)

export default component.exports